import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "../features/auth/hooks/useAuth";
import useProfile from "../features/account_settings/hooks/useProfile";
import { ProfileTypeEnum } from "../constant";

interface ProtectedRouteProps {
  sitterOnly?: boolean;
}

const ProtectedRoute = ({ sitterOnly = false }: ProtectedRouteProps) => {
  const { isAuthenticated } = useAuth();
  const { userProfile } = useProfile();
  const location = useLocation();

  const protectedRoutePaths = [
    "/dashboard",
    "/dashboard/feedback",
    "/dashboard/favorites",
    "/messages",
    "/profile/about-me",
    "/profile/address",
    "/profile/phone",
    "/profile/notification",
    "/profile/delete",
    "/profile/password",
    "/profile/my-pets",
    "/profile/availability",
    "/profile/services",
    "/sitter/complete-profile",
    "/sitter/address",
    "/sitter/headline",
    "/sitter/photo-gallery",
    "/sitter/experience",
    "/sitter/payout-method",
  ];

  const currentPath = location.pathname;
  if (!isAuthenticated) {
    if (currentPath === "/sitter/application") {
      // const redirectTo = encodeURIComponent(
      //   `${FRONTEND_URL}${currentPath + location.search}`,
      // );
      return (
        <Navigate
          // to={`/sign-up?redirect_url=${redirectTo}`}
          to={`/sign-up`}
          replace
          state={{ ...location.state, from: location }}
        />
      );
    } else if (protectedRoutePaths.includes(currentPath)) {
      // const redirectTo = encodeURIComponent(
      //   `${FRONTEND_URL}${currentPath + location.search}`,
      // );
      return (
        <Navigate
          // to={`/login?redirect_url=${redirectTo}`}
          to={`/login`}
          replace
          state={{ ...location.state, from: location }}
        />
      );
    } else {
      return (
        <Navigate
          to={`/login`}
          replace
          state={{ ...location.state, from: location }}
        />
      );
    }
  }

  if (sitterOnly && userProfile && userProfile?.profile_type !== ProfileTypeEnum.SITTER) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
